import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import PostUser from 'flarum/forum/components/PostUser';
import Avatar from 'flarum/common/components/Avatar';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import TicketLabels from './components/TicketLabels';
import TicketControls from './components/TicketControls';
import { canManageTickets, canStartTicket, guestTicketsEnabled, isTicket, ticketGuest } from '../common/utils/tickets';
export default function addTickets() {
  // "Tickets" link for users who can open or handle tickets.
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    // Visitors find the guest ticket form there, when it is enabled.
    if (app.session.user ? !(canStartTicket() || canManageTickets()) : !guestTicketsEnabled()) return;
    items.add('tickets', m(LinkButton, {
      href: app.route('support.tickets'),
      icon: "fas fa-ticket"
    }, app.translator.trans('soup-97-support.forum.nav.tickets')), 94);
  });

  // Status, priority and assignee in the ticket list.
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const discussion = this.attrs.discussion;
    if (!isTicket(discussion)) return;
    items.add('ticket', m(TicketLabels, {
      discussion: discussion,
      showAssignee: canManageTickets()
    }), 110);
  });

  // Ticket page: a class for styling, and the ticket box in the sidebar.
  extend(DiscussionPage.prototype, 'view', function (vdom) {
    const discussion = app.current.get('discussion');
    if (!discussion || !isTicket(discussion)) return;
    const attrs = vdom.attrs;
    attrs.className = classList(attrs.className, 'DiscussionPage--ticket');
  });
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const discussion = app.current.get('discussion');
    if (!discussion || !isTicket(discussion)) return;
    items.add('ticket', m(TicketControls, {
      discussion: discussion
    }), 90);
  });

  // Guest posts have no user: show the name the guest gave (staff only see these).
  extend(PostUser.prototype, 'noUserViewItems', function (items, user, post) {
    const guest = post.supportByGuest() && ticketGuest(post.discussion());
    if (!guest) return;
    items.setContent('postUser-name', m("h3", {
      className: "PostUser-name"
    }, m(Avatar, {
      user: null,
      className: "Post-avatar"
    }), " ", m("span", {
      className: "username"
    }, guest.name), ' ', m("span", {
      className: "TicketLabel TicketLabel--guest"
    }, app.translator.trans('soup-97-support.forum.ticket.guest_label'))));
  });
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    if (!isTicket(discussion)) return;
    items.add('ticket', m("nav", {
      className: "TicketBreadcrumb"
    }, m(Link, {
      href: app.route('support.tickets')
    }, m(Icon, {
      name: "fas fa-ticket"
    }), " ", app.translator.trans('soup-97-support.forum.ticket.number', {
      id: discussion.id()
    }))), 20);
    items.add('ticketLabels', m(TicketLabels, {
      discussion: discussion
    }), -10);
    if (discussion.ticketStatus() === 'closed' && !discussion.canReply()) {
      items.add('ticketClosed', m("p", {
        className: "TicketClosedNotice"
      }, app.translator.trans('soup-97-support.forum.ticket.closed_notice')), -20);
    }
  });
}

/**
 * Rows in Settings → Notifications. Staff-only types are shown to staff only.
 */
export function addTicketNotificationSettings() {
  // NotificationGrid is lazy-loaded with the settings page: extend it by module name.
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    const label = key => app.translator.trans(`soup-97-support.forum.settings.${key}`);
    if (canStartTicket() || canManageTickets()) {
      items.add('supportStaffReplied', {
        name: 'supportStaffReplied',
        icon: 'fas fa-headset',
        label: label('notify_staff_replied_label')
      });
      items.add('supportTicketStatusChanged', {
        name: 'supportTicketStatusChanged',
        icon: 'fas fa-ticket',
        label: label('notify_status_changed_label')
      });
    }
    if (canManageTickets()) {
      items.add('supportTicketCreated', {
        name: 'supportTicketCreated',
        icon: 'fas fa-ticket',
        label: label('notify_ticket_created_label')
      });
      items.add('supportCustomerReplied', {
        name: 'supportCustomerReplied',
        icon: 'fas fa-reply',
        label: label('notify_customer_replied_label')
      });
    }
  });
}